import React, { useState } from 'react';
import Td from '@visa/vds/td';
import Tr from '@visa/vds/tr';
import MCSPagedTable from '../../../../components/MCSPagedTable';
import MCSLoading from '../../../../components/MCSLoading';
import { DateHelper } from '../../../../_helpers/DateHelper';
import Link from '@visa/vds/link';
import { HOME } from '../../../../_constants/PageRoutes';

function Announcement(props) {
    let colHeaders = [
        { displayName: "Id", name: "Id", orderable: false },
        { displayName: "Fee Waiver or Fee Discount Type", name: "SelectionType", orderable: false },
        { displayName: "Description (Client Facing)", name: "Description", orderable: false },
        { displayName: "Discount Offer Start Date (*GMT)", name: "StartDate", orderable: false },
        { displayName: "Discount Offer End Date (*GMT)", name: "EndDate", orderable: false },
        { displayName: "Discount Offer Duration", name: "DurationDescription", orderable: false },
        // { displayName: "Fee Waiver or Fee Discount FAQs", name: "FaqDisplayName", orderable: false, link: true },
        { displayName: "VSS Product Details", name: "ApplicableProductSubscription", orderable: false },
        { displayName: "Discount Details", name: "Percentage", orderable: false }
    ];

    if (!props.fetched) {
        return (<MCSLoading />)
    }
    else {

        return (
            <>
                <MCSPagedTable size={"compact"}
                    colHeaders={colHeaders}
                    useSearchBar={false}
                    
                    tableData={
                        props.feeWaivers && props.feeWaivers.sort((a, b) => {
                            if (a.id > b.id) return 1
                            else if (a.id < b.id) return -1
                            else return 0
                        }).map((row, key) => (
                            
                            <Tr key={key}>
                                <Td>{row.id}</Td>
                                <Td>{(row.selectionType==1)? "User select" : "null"}</Td>
                                <Td>{(row.description)}</Td>
                                <Td>{(row.startDate ? DateHelper.ToFormattedGMTDate(row.startDate, "dd MMM yyyy HH:mm*") : '')}</Td>
                                <Td>{(row.endDate ? DateHelper.ToFormattedGMTDate(row.endDate, "dd MMM yyyy HH:mm*") : '')}</Td>
                                <Td>{(row.durationDescription)}</Td>
                                {/* <Td>
                                    <Link href={(HOME + row.faqUrl)} target="_blank" rel="noopener noreferrer">
                                    {(row.faqDisplayName)}
                                    </Link>
                                </Td> */}
                                <Td>{(row.applicableProductSubscription)}</Td>
                                <Td>{(row.percentage)}%</Td>
                            </Tr>
                        ))
                    } />
            </>
        );
    }
}

export default Announcement;